module.exports = __webpack_public_path__ + "static/box-fd5848bd27200e335d136b0e837fca31.png";